import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, Typography } from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import DiscountIcon from '@mui/icons-material/Discount';
import { GlobalBox } from "components/Box/GlobalBox";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import RegularButton from "components/CustomButtons/Button";
import { GeneralInfoColumn } from "./GeneralInfoColumn";
import { InformationColumn } from "./InformationColumn";
import { OrdersColumn } from "./OrdersColumn";
import {
  getCustomerServices,
  getCustomerCyclesType,
  getCustomerConditions,
  getCustomerContracts,
  hideCostAction,
  getAccountData,
  getCreditAccount,
  updateDiscountType,
} from "redux/actions/customers/customersAction";
import { CUSTOMERS_TYPES } from "redux/reducers/customers/customersTypes";
import { PERMISSIONS } from "router/permissions";
import { validateObject } from "helpers/validateObject";
import { getItemLocalStorage } from "helpers/localstorageTool";
import { IsCreditNote } from "./IsCreditNote";
import { useRuleValidator } from "hooks/useRuleValidator";
import { useToggle } from "hooks/useToggle";
import { ModalV2 } from 'components/Modal/ModalV2';

const h = 85;
export const height = `${h}vh`;
export const fontSize = 150;
export const iconStyle = { margin: 0, fontSize: 32, opacity: 0.4 };
const cVal = 500;

export const CustomerView = () => {
  const { CUSTOMER_HIDE_COST, CUSTOMER_DISCOUNT_TYPE } = PERMISSIONS;
  const canHideCost = useRuleValidator(CUSTOMER_HIDE_COST);
  const canChangeDiscountType = useRuleValidator(CUSTOMER_DISCOUNT_TYPE);

  const hist = useHistory();
  const PHONE = getItemLocalStorage("callPhone");
  const dispatch = useDispatch();
  const {
    customer,
    loadingCustomerData,
    newCustomerMode,
    account,
  } = useSelector(({ customersReducer }) => customersReducer);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { id, accountId, code } = useParams();
  const [open, setOpen] = useToggle();

  const creditAccount = account?.creditAccounts;
  const nextDiscountType = customer?.discountType === "LT" ? "PU" : "LT";

  const handleNav = () => {
    hist.push("/admin/crm_clientes");
    dispatch({
      type: CUSTOMERS_TYPES.NEW_CUSTOMER_MODE,
      payload: true,
    });
  };
  const handleHideCost = () => {
    dispatch(hideCostAction(id, !customer?.hideCost));
  };

  const handleChangeDiscountType = () => {
    dispatch(updateDiscountType(customer?.id, { discountType: nextDiscountType }, setOpen))
  }

  useEffect(() => {
    dispatch(getCustomerCyclesType());
    if (account && validateObject(account, true)) {
      // dispatch(getCustomerData(id));
      dispatch(getAccountData(id, code, accountId));
    }

    dispatch(getCustomerServices(id));
    dispatch(getCustomerConditions(id));
    dispatch(getCustomerContracts(id));

    // Al salir de la vista se limpian las listas de detalle para que la próxima
    // navegación no renderice residuos de este cliente.
    return () => {
      dispatch({ type: CUSTOMERS_TYPES.CLEAN_CUSTOMER_DETAIL });
    };
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    id &&
      dispatch({
        type: CUSTOMERS_TYPES.NEW_CUSTOMER_MODE,
        payload: false,
      });
    //eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    if(account !== null && validateObject(account) && account?.code?.includes("ERP-") && !Object(account).hasOwnProperty("creditAccounts")) {
      dispatch(getCreditAccount(account.id))
    }
  }, [account])

  return (
    <>
      <GlobalBox
        title={
          <Box>
            <Typography>{customer?.name}</Typography>
            {customer?.isCreditSuspended === 1 && (
              <Typography
                style={{ fontSize: 12, color: red[cVal] }}
              >{`Credito Suspendido`}</Typography>
            )}
            {!customer?.isCreditSuspended && customer?.credit && (
              <Typography style={{ fontSize: 12 }}>
                {`Credito Disponible: ${customer?.credit}`}
              </Typography>
            )}
            <IsCreditNote account={creditAccount} />
          </Box>
        }
        icon={<AccountCircleIcon />}
        style={{
          position: !PHONE && newCustomerMode ? "absolute" : "",
        }}
        controls={
          <>
            {canChangeDiscountType ? (
              <RegularButton
                justIcon
                round
                color="twitter"
                size="sm"
                tooltip={`Cambiar tipo descuento a ${nextDiscountType}`}
                onClick={setOpen}
              >
                <DiscountIcon style={{ margin: 0 }} />
              </RegularButton>
            ) : null}
            {canHideCost ? (
              <RegularButton
                justIcon
                round
                color={customer?.hideCost ? "success" : "warning"}
                size="sm"
                tooltip={
                  customer?.hideCost
                    ? "Mostrar precios"
                    : "No mostar precios"
                }
                onClick={handleHideCost}
              >
                {customer?.hideCost ? (
                  <AttachMoneyIcon style={{ margin: 0 }} />
                ) : (
                  <MoneyOffIcon style={{ margin: 0 }} />
                )}
              </RegularButton>
            ) : null}
            <RegularButton
              justIcon
              round
              color="twitter"
              size="sm"
              tooltip="Regresar"
              onClick={handleNav}
            >
              <ArrowBackIcon style={{ margin: 0 }} />
            </RegularButton>
          </>
        }
      >
        <Grid
          container
          spacing={1}
          style={{ marginTop: 24, height, borderRadius: 12 }}
        >
          {loadingCustomerData ? (
            <LoadingComponent />
          ) : (
            <>
              <GeneralInfoColumn />
              <InformationColumn />
              <OrdersColumn />
            </>
          )}
        </Grid>
      </GlobalBox>
      <ModalV2
        open={open}
        onClose={setOpen}
        title={`¿Seguro que desea cambiar tipo de descuento a ${nextDiscountType}?`}
        justConfirm
        onSubmit={handleChangeDiscountType}
        isLoading={isLoadingComp?.loadingCustomers}
      />
    </>
  );
};
